import { kinoLimits, lobby, room, socket ,Video, animatedLayers, permissions} from "../libs/roomnew";
import moment from 'moment';
export default class JoinRequest{
    constructor(){
        this.requests={};
        this.onAccept=()=>{};
        this.onReject=()=>{};
        this.onSocketConnected=()=>{};
        this.minimizedContainer=null;
        this.timeUpdater=0;
        this.notification;
        this.timeout;

        this.watingForSocket=false;
        this.addPeopleBtn = `<svg xmlns="http://www.w3.org/2000/svg" width="140" height="102" viewBox="0 0 140 102" fill="none"><path d="M89.0909 50.9091C103.155 50.9091 114.545 39.5182 114.545 25.4545C114.545 11.3909 103.155 0 89.0909 0C75.0273 0 63.6364 11.3909 63.6364 25.4545C63.6364 39.5182 75.0273 50.9091 89.0909 50.9091ZM89.0909 12.7273C96.0909 12.7273 101.818 18.4545 101.818 25.4545C101.818 32.4545 96.0909 38.1818 89.0909 38.1818C82.0909 38.1818 76.3636 32.4545 76.3636 25.4545C76.3636 18.4545 82.0909 12.7273 89.0909 12.7273ZM89.0909 63.6364C72.1 63.6364 38.1818 72.1636 38.1818 89.0909V101.818H140V89.0909C140 72.1636 106.082 63.6364 89.0909 63.6364ZM50.9091 89.0909C52.3091 84.5091 71.9727 76.3636 89.0909 76.3636C106.273 76.3636 126 84.5727 127.273 89.0909H50.9091ZM31.8182 70V50.9091H50.9091V38.1818H31.8182V19.0909H19.0909V38.1818H0V50.9091H19.0909V70H31.8182Z" fill="#F8F8F8"/></svg>`;
    };
    addSocketEvents(){
        socket.events.RoomJoinRequest=this.requestReceived.bind(this);
        //moderator notification
        socket.events.moderatorResponse = this.requestUpdated.bind(this);
        socket.events.moderatorRequests = this.multipleJoinRequests.bind(this);
        socket.events.requestCanceled = this.onRequestCancel.bind(this)
    };
    addResponseListener(){
        socket.events.RoomJoinResponse=(response)=>{
            try {
                socket.requestsRoom('leave');
                if (response.data.answer == 'accepted') {
                    kinoLimits.hideParticipantsLimitModal();
                    this.onAccept.call(this,response);
                }else{

                    this.onReject.call(this,response);
                }
            } catch (error) {
                console.error(error);
            }
        };
        socket.events.ModeratorsAvailable=(message)=>{
            if(message.data.available){
                if(kinoLimits.isModalShown()){
                    kinoLimits.setMessage(`Your request has been sent, please wait for the host to accept`,false,true);
                }
                // lobby.setMessage('Your request has been sent, please wait for the host to accept.',false);
                if(kinoLimits.isParticipantLimitReached()){
                    lobby.showJoiningOverlay('This Kino has reached the limit of participants <br/> Please wait, your request can be accepted as soon as someone leaves', true, 'Participants limit reached');
                }else{
                    lobby.showJoiningOverlay('Your request has been sent, please wait for the host to accept.');
                }
                animatedLayers.removeScheduledKinoInfo();
            }else{
                if(kinoLimits.isModalShown()){
                    kinoLimits.setMessage(`Host and moderators are not available, please stand by`,false,true);
                }
                // lobby.setMessage('Host and moderators are not available, please stand by.',false);
                lobby.showJoiningOverlay('Host and moderators are not available, please stand by.');
                animatedLayers.removeScheduledKinoInfo();
            }
        };
    };

    multipleJoinRequests(message){
        message.data.forEach(request => {
            this.requestReceived({data:request});
        });
    };

    startTimeUpdater(){
        this.stopTimeUpdater();
        this.timeUpdater=setInterval(this.updateNotificationTime.bind(this),50000);
    };
    updateNotificationTime(){
        Object.values(this.requests).map(r=>{
            let timefromNow=moment(r.requestTime).fromNow();
            r.html.find(".request-time-from").html(timefromNow);
        })
    };
    stopTimeUpdater(){
        clearInterval(this.timeUpdater);
        this.timeUpdater=0;
    };
    requestReceived(request){
        if(!permissions.canAcceptUsers() || this.requests[request.data.resourceId]){return};
        let requestTime=new Date();
        let accept = $('<button/>', {
            class: 'btn btn-primary btn-sm kino-btn-primary ml-2 px-4 py-2',

            html: 'Accept',
          });
          let refuse = $('<button/>', {
            class: 'btn btn-sm kino-btn-secondary px-3 py-2',
            html: 'Reject',
          });
          let closeToast = $('<div/>',{
            class: '',
            html: `<button type="button" class="close-join-toast kino-color-primary" data-toggle="tooltip" data-placement="top"  data-original-title="Minimize notification" data-dismiss="toast" aria-label="Close"><i class="fas fa-window-minimize"></i></button>`,
          });

          let body = $('<div/>', {
            class: 'toast-body toast-body-modified',
            html: `<div class="d-flex my-2">
                    <div class="toast-name-container"  data-toggle="tooltip" data-placement="top"  data-original-title="${request.data.displayName}">${request.data.displayName} </div>is requesting to enter this Kino.
                </div>
           <p class="font-weight-normal text-sm mb-0">You can either Accept, Reject, or Minimize this notification.</p>`,
          });
          let limitMessage=$('<div/>',{
              class:'request-participant-limit-message',
              html: '<i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size:0.75rem;"></i> Participants limit reached'
          });
          let time=$("<span/>",{
              class:"request-time-from",
              html:moment(requestTime).fromNow()
          });
          let footer = $('<div/>', {
            class: 'toast-footer toast-footer-modified pt-0',
            html: [time,refuse, accept],
          });
          const toasHeader=$('<div/>',{
                class:'request-access-header',
                html:[
                    `<p class='font-weight-bold kino-color-primary mb-0 px-2 py-2'>Access Request</p>`
                ]
          })
          this.notification = $('<div/>', {
            class: 'toast toast-modified join-notification',
            role: 'alert',
            'aria-live': 'assertive',
            'aria-atomic': true,
            'z-index': 5000,
            id: request.data.guestId,
            resID: request.data.resourceId,
            style: 'width:100%; margin-top:8px; margin-bottom:0px;',
            html: [toasHeader,kinoLimits.isParticipantLimitReached() ? limitMessage : null,body,closeToast, footer],
          });

          closeToast.on('click', (e)=> {
            e.stopPropagation();
            this.removeRequest(request.data.resourceId);
          })

          accept.on('click', (e) => {
              e.stopPropagation()
              if(kinoLimits.isParticipantLimitReached()){return}
              kinoLimits.onUsersCountChanged(1,false);
              this.acceptRequest(request.data.resourceId);
          });
          if(kinoLimits.isParticipantLimitReached()){
              accept.attr('disabled', "disabled");
          }
          refuse.on('click', (e) => {
              e.stopPropagation()
              this.rejectRequest(request.data.resourceId);
          });

          $('#notifications').prepend(this.notification);
          this.notification.toast({
              animation: true,
              autohide: false
          });
          Video.sounds.play('join');
          this.notification.toast('show');

          this.requests[request.data.resourceId]={
              data:request.data,
              html:this.notification,
              minimized:false,
              requestTime:requestTime,
              acceptBtn:accept,
              limitMessage:limitMessage
          };
          if(!this.timeUpdater){
              this.startTimeUpdater();
          }

    };
    removeRequest(id){
        try {
            try {
                let animationTimeout;
                clearTimeout(animationTimeout);
                // this.notification.addClass('translateXUp')
                // this.timeout = setTimeout(() =>{
                    // this.notification.removeClass('translateXUp')
                    //this.requests[id].html.remove();
                    this.requests[id].minimized=true;
                    let minimized=this.countMinimizedRequests();
                    if( minimized > 0 && !this.minimizedRequests){
                        this.addMinimizedContainer();
                        animationTimeout = setTimeout(()=>{
                            this.minimizedRequests.addClass('opaque')
                        },30)
                    }else if(minimized > 0 && this.minimizedNumberBadge){
                        this.minimizedNumberBadge.html(minimized);
                    }
                    this.requests[id].html.toast('hide');
                // },0)
            } catch (error) {

            }
        } catch (error) {

        }
    };
    deleteRequest(id){
        this.requests[id].html.toast('dispose');
        this.requests[id].html.remove();
        delete this.requests[id];
        let minimized=this.countMinimizedRequests();
        let allRequests=Object.keys(this.requests).length;
        if(minimized == 0){
            this.removeMinimizedRequests();
        }else{
            this.minimizedNumberBadge.html(minimized);
        }
        if(allRequests==0){
            this.stopTimeUpdater();
        }
    }
    rejectRequest(id){
        try {
            socket.sendJoinRefused(this.requests[id].data);
            this.deleteRequest(id);
        } catch (error) {

        }
    };
    acceptRequest(id){
        socket.sendJoinAccept(this.requests[id].data);
        this.deleteRequest(id);
    };
    isModerator(){
        return ROLE == "moderator" || HOST==1;
    };

    requestUpdated(request){
        if(request.data.answer=="accepted"){
            kinoLimits.onUsersCountChanged(1,false);
        }
        this.deleteRequest(request.data.resID);
    };

    onRequestCancel(request){
        // if(request.data.answer=="accepted"){
        //     kinoLimits.onUsersCountChanged(1,false);
        // }
        this.deleteRequest(request.data.resID);
    };

    addMinimizedContainer(){

        this.minimizedNumberBadge=$("<span/>",{
            html:this.countMinimizedRequests(),
            class:"toast-minimized-count-badge"
        });

        let minimizedInnerCircle = $('<div/>',{
            class: 'toast-minimized-inner-circle',
            html: this.addPeopleBtn
        });

        let minimizeContainer = $('<div/>', {
            class: 'toast-join-requests-minimized',
            html: [this.minimizedNumberBadge, minimizedInnerCircle],
        });

        this.minimizedRequests = $('<div/>', {
        class: 'toast-join-requests-minimized-container',
        style: 'float:left',
        html: [minimizeContainer],
        }).on('click',(e)=>{
        this.showMinimizedRequests();
        });

        $('#notifications').append(this.minimizedRequests);
    };
    showMinimizedRequests(){
        Object.values(this.requests).filter(r=>r.minimized).map(r=>{
            r.html.toast('show');
            r.minimized=false;
        });
        this.removeMinimizedRequests();
    };
    removeMinimizedRequests(){
        clearTimeout(this.timeout);
        if(this.minimizedRequests){
        this.minimizedRequests.removeClass('opaque')
        // this.notification.addClass('translateXDown')
        this.timeout = setTimeout(()=>{
            // this.notification.removeClass('translateXDown')
            this.minimizedRequests.remove();
            this.minimizedNumberBadge.remove();
            this.minimizedRequests=null;
            this.minimizedNumberBadge=null;
        },200)
        }
    };
    countMinimizedRequests(){
        return Object.values(this.requests).filter(r=>r.minimized).length;
    };

    sendJoinRequest(data){
        this.watingForSocket=false;
        socket.sendRoomJoinRequest(data);
    };

    makeRequestsEnabled(enabled){
        if(!permissions.canAcceptUsers()){return}
        Object.values(this.requests).map(r=>{
            if(enabled){
                r.acceptBtn.removeAttr('disabled');
                r.limitMessage.html('');
            }else{
                r.acceptBtn.attr('disabled','disabled');
                r.limitMessage.html('Participants limit reached');
            }
        });
    };
};
